module.exports = "<div class=\"login\">\r\n  <div *ngIf=\"!logged\">\r\n    Merci de vous identifier\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Quentin/projets/kontractor/src/app/components/login/login.component.html
// module id = ../../../../../src/app/components/login/login.component.html
// module chunks = main